export default __webpack_public_path__ + "static/media/icon-verifyid.87b51b96.svg";